var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPragmategraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 473.11 463.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #a7a9ac;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3, .cls-5, .cls-6 {\n        fill: #414042;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #fff;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        stroke: url(#Orange_Yellow);\n      }\n\n      .cls-6 {\n        stroke: url(#Orange_Yellow-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Orange_Yellow",
    "data-name": "Orange, Yellow",
    x1: 99.73,
    y1: 175.27,
    x2: 436.22,
    y2: 175.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fee62d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fdd51b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fdca0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fdc70c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f3903f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ed683c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e93e3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Orange_Yellow-2",
    "data-name": "Orange, Yellow",
    y1: 265.59,
    x2: 208.72,
    y2: 265.59,
    xlinkHref: "#Orange_Yellow"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "428.78 7.24 420.76 316.81 93.32 308.32 101.29 .51 428.78 7.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "414.93 18.31 406.92 327.88 79.47 319.4 87.44 11.58 414.93 18.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "380.31 12.77 372.29 322.34 44.85 313.86 52.82 6.05 380.31 12.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "408.01 58.18 399.99 367.75 72.54 359.27 80.52 51.45 408.01 58.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "435.71 23.85 427.69 333.41 100.24 324.93 108.21 17.12 435.71 23.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "421.86 29.38 413.84 338.95 86.39 330.47 94.36 22.66 421.86 29.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "394.16 34.92 386.14 344.49 58.69 336.01 66.67 28.19 394.16 34.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "401.08 40.46 393.07 350.02 65.62 341.54 73.59 33.73 401.08 40.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "387.24 45.99 379.22 355.56 51.77 347.08 59.74 39.26 387.24 45.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m226.43,276.32c0,46.02-37.31,83.32-83.32,83.32-11.55,0-22.55-2.35-32.56-6.6-3.23-1.37-6.36-2.94-9.36-4.7-1.3-.76-72.62,115.23-73.87,114.41-.92-.61-25.7-21.98-26.6-22.62-1.59-1.14,90.78-98.36,89.28-99.6-4.5-3.73-8.6-7.92-12.23-12.5-11.26-14.21-17.99-32.18-17.99-51.71,0-46.02,37.31-83.32,83.32-83.32s83.32,37.31,83.32,83.32Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "208.71 327.74 100.24 324.93 103.4 202.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m226.43,276.32c0,46.02-37.31,83.32-83.32,83.32-11.55,0-22.55-2.35-32.56-6.6-3.23-1.37-6.36-2.94-9.36-4.7-1.3-.76-72.62,115.23-73.87,114.41-.92-.61-25.7-21.98-26.6-22.62-1.59-1.14,90.78-98.36,89.28-99.6-4.5-3.73-8.6-7.92-12.23-12.5-11.26-14.21-17.99-32.18-17.99-51.71,0-46.02,37.31-83.32,83.32-83.32s83.32,37.31,83.32,83.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "90 340.53 101.18 348.35 27.31 462.75 .71 440.13 90 340.53"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m230.14,64.52l-10.64-2.3h0l5.05,9.25-1.8,2.07s59.4,50.54,92.21,64.91c1.79.78,4.34.65,4.34.65,0,0,.71,1.93,2.57,3.67,29.91,28.05,105.04,77.6,134.67,98.5,5.93,4.19,15.92-13.8,15.92-13.8l-12.4-9.07,6.38-8.83s-54.1-47.77-73.05-59.57c-1.83-1.14-15.76-7.89-15.76-7.89l76.68,66.26s-8.36-.94-10.74-2.31c-28.82-16.6-80.12-65.75-110.07-77.69-2.2-.88-5.74-1.2-5.74-1.2,0,0-.92-3.79-3.46-5.83-40.15-32.17-92.37-59.28-92.37-59.28l-1.77,2.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPragmategraphic);
export default __webpack_public_path__ + "static/media/pragmate graphic.f6dc957c75c122bdc38559856112839a.svg";
export { ForwardRef as ReactComponent };